(() => {
  'use strict';

  const months = [
    'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
    'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
  ];

  const pad2 = (n) => (n < 10 ? `0${n}` : `${n}`);

  const addDays = (base, days) => {
    const d = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    d.setDate(d.getDate() + days);
    return d;
  };

  const formatRange = (d1, d2) => {
    const sameMonth = d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
    if (sameMonth) {
      return `entre <strong>${pad2(d1.getDate())}</strong> e <strong>${pad2(d2.getDate())} de ${months[d2.getMonth()]}</strong>.`;
    }
    return `entre <strong>${pad2(d1.getDate())} de ${months[d1.getMonth()]}</strong> e <strong>${pad2(d2.getDate())} de ${months[d2.getMonth()]}</strong>.`;
  };

  const getIpLocation = async () => {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 3000);
      const r = await fetch('https://ipapi.co/json/', { signal: controller.signal });
      clearTimeout(timeoutId);
      if (!r.ok) throw new Error('ipapi fail');
      const j = await r.json();
      const city = j.city;
      const region = j.region_code || j.region || '';
      if (city) return `${city}${region ? `, ${region}` : ''}`;
    } catch {
      /* ignore */
    }
    return null;
  };

  document.querySelectorAll('script[data-frete-config]').forEach((node) => {
    let config;
    try {
      config = JSON.parse(node.textContent);
    } catch {
      return;
    }

    const { sectionId, minDays, maxDays, serviceName, regionSuffix, defaultLocation } = config;
    if (!sectionId) return;

    const setEstimated = () => {
      const el = document.getElementById(`sp-estimated-${sectionId}`);
      if (!el) return;
      const now = new Date();
      el.innerHTML = `Entrega estimada ${formatRange(addDays(now, minDays), addDays(now, maxDays))}`;
    };

    const setAddress = (locationText) => {
      const el = document.getElementById(`sp-address-${sectionId}`);
      if (!el) return;
      const suffix = regionSuffix || '';
      el.innerHTML = `<b>${serviceName}</b> para <strong>${locationText}${suffix}</strong>`;
    };

    const showLoading = (visible) => {
      const el = document.getElementById(`sp-loading-${sectionId}`);
      if (el) el.hidden = !visible;
    };

    const hydrateLocation = async () => {
      showLoading(true);
      setEstimated();
      const pretty = await getIpLocation();
      if (pretty) {
        setAddress(pretty);
      } else {
        setAddress(defaultLocation || 'sua região');
      }
      showLoading(false);
    };

    const runWhenIdle = (fn) => {
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(() => fn(), { timeout: 5000 });
      } else {
        setTimeout(fn, 0);
      }
    };

    runWhenIdle(hydrateLocation);
  });
})();
